import { render } from "./form-dataset-default.vue?vue&type=template&id=2968d01c"
import script from "./form-dataset-default.vue?vue&type=script&lang=js"
export * from "./form-dataset-default.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__